import {Quote} from "../../api/models";
import React, {CSSProperties, useRef, useState} from "react";
import {Button, Input, Popover} from "antd";
import Configurator from "../../pages/configurator";
import TextArea from "antd/es/input/TextArea";

const QuoteNameInput = (props:{
    quote:Quote | undefined
    readOnly?: boolean
    onChange?: (n: string | undefined) => void
    txtStyle?: CSSProperties
    btnStyle?: CSSProperties
}) => {

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const inputRef = useRef<any>(null);
    const btnTxtStyle = {
        borderBottom: "1px solid black",
        ...props.txtStyle,
    };
    const [quoteName, setQuoteName] = useState<string>();

    const handleOpen = () => {
        setQuoteName( props.quote?.name );
        setIsOpen(true);
    }
    const handleBlur = () => {

        setIsOpen(false);

        props.onChange?.( quoteName );
    }

    const btnTitle = props.quote?.name ? props.quote?.name : "None";
    return <Popover
        trigger={"click"}
        afterOpenChange={(open) => {
            if( open ) {
                inputRef.current?.focus();
            }
        }}
        open={isOpen}
        content={<TextArea
            style={{width: "30rem"}}
            ref={inputRef}
            value={quoteName}
            placeholder="Type quote name."
            onChange={(e) => setQuoteName(e.target.value)}
            onBlur={handleBlur}
            onPressEnter={() => inputRef.current?.blur()}
        /> }
        arrow={false}
    >
        {props.readOnly ?
            <span style={props.txtStyle}>{btnTitle}</span>
            :props.quote?.name
                ? <Button className="ghostBmButton" type="text" onClick={handleOpen}
                          title={btnTitle}
                          style={{
                              ...props.btnStyle,
                              margin: 0,
                              padding: 0
                          }} >
                    <span style={btnTxtStyle}>{btnTitle}</span>
                </Button>
                :<span style={props.txtStyle}>{btnTitle}</span>}
    </Popover>;
}

export default QuoteNameInput;
